module.exports = __webpack_public_path__ + "media/fr_ca_s1_Emanuel.0ce8211c.oga";